import React, { useMemo } from 'react';
import { Box } from '@mui/joy';
import { useTranslation } from 'react-i18next';
import { WidgetBookingsCountCalendar } from 'src/mtska-frontend-app-component';
import List from './List';

const Default = () => {
    const { t } = useTranslation();

    return useMemo(() => (
        <>
            <Box className="dashboard-portion" sx={{ mb: 3 }}>
                <Box className="dashboard-portion-title">{t('Bookings overview')}</Box>
                <WidgetBookingsCountCalendar />
            </Box>
            <List />
        </>
    ), [t]);
};

export default Default;
